import React from "react";

/**
 * The document's ground (#11426): the editor sits on the design system's page
 * ground with the document as a surface card — the same pair the Reports
 * templates page uses, so moving between the list and a report changes the
 * content, not the ground. One component so the report editor, the template
 * editor and any future document surface cannot drift apart.
 */
export const EditorGround: React.FC<{
  children: React.ReactNode;
  /** Inside a pane that is itself the card (#12481): no page ground and no
   *  sheet, the document sits on the host's surface at the reading measure. */
  flat?: boolean;
}> = ({ children, flat = false }) =>
  flat ? (
    <div data-testid="editor-ground" className="min-h-full">
      <div className="mx-auto max-w-3xl">{children}</div>
    </div>
  ) : (
    <div
      data-testid="editor-ground"
      className="min-h-full bg-[var(--fp-bg)] py-4"
    >
      <div className="mx-auto max-w-3xl">
        <div
          data-testid="editor-sheet"
          className="min-h-[calc(100vh-2rem)] rounded-[12px] border border-[var(--fp-border)] bg-[var(--fp-surface)] [box-shadow:var(--fp-lift)]"
        >
          {children}
        </div>
      </div>
    </div>
  );
